import { IWebSocket } from '@/services/WebSocketService';
import { ref } from 'vue';

export default function useWebSocket(socketService: IWebSocket) {

  const channel = ref({
    name: '',
    event: ''
  })
  const connectWebSocket = () => {
    socketService.connect()
  }
  const disconnectWebSocket = () => {
    socketService.disconnect()
  }
  const subscribeToEvent = async (channel_name: string, event_name: string, callback: (event: any) => void) => {
    try {
      channel.value.name = channel_name
      channel.value.event = event_name
      console.log(`[useWebSocket] ✅ Subscribing to Pusher channel: "${channel_name}" with event: "${event_name}"`)
      socketService.subscribe(channel_name).bind(event_name, (e: any) => {
        console.log(`[useWebSocket] 📥 Event received on channel "${channel_name}" with event "${event_name}":`, e)
        callback(e)
      });
    } catch (e) {
      console.error('[useWebSocket] ❌ Subscription error:', e)
    } finally {
    }
  }
  const unsubscribeFromChannel = async () => {
    if (!channel.value.name) return
    try {
      socketService.unsubscribe(channel.value.name, channel.value.event)
    } catch (e) {
      console.error(e)
    } finally {
    }
  }
  return {
    connectWebSocket,
    disconnectWebSocket,
    subscribeToEvent,
    unsubscribeFromChannel
  };
}